import React from 'react';
import { ELEMENTS, ElementType } from '../utils/baziData';
interface ElementBadgeProps {
  char: string;
  element: ElementType;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export const ElementBadge: React.FC<ElementBadgeProps> = ({
  char,
  element,
  size = 'md',
  className = ''
}) => {
  const elConfig = ELEMENTS[element];
  const sizeClasses = {
    sm: 'w-6 h-6 text-sm',
    md: 'w-10 h-10 text-xl',
    lg: 'w-14 h-14 text-3xl'
  };
  return <div className={`flex items-center justify-center rounded-full border-2 font-serif font-bold shadow-sm
        ${sizeClasses[size]} ${className}`} style={{
    borderColor: `var(--color-element-${element})`,
    color: `var(--color-element-${element})`,
    backgroundColor: `color-mix(in srgb, var(--color-element-${element}) 8%, white)`
  }} title={`${char} (${elConfig.name})`} data-id="element-30">
      {char}
    </div>;
};